import { createContext } from "react";
import { MapContextInterface, State } from "./types";

export const MapStateContext = createContext<MapContextInterface | undefined>(undefined);

export const initialValues = {
  mapContext: undefined
} as State;
